export class QRModel{
  Email:string;
  cSUser:string;
  cSPassword:string;
  Server:string;
  Port:string;
  cSUserId:number;
  sUser:string;
  sPassword:string;
  SchemaName:string;
  MapCacheId:string;
  MapCacheName:string;
  Language:string;
}
